import {
    DrawCircleFromCenterMode,
    DrawLineStringMode,
    DrawPointMode,
    DrawPolygonMode,
    DrawRectangleMode,
    ModifyMode,
    ViewMode,
} from '@nebula.gl/edit-modes';
import DrawLimitedLineStringMode from 'utils/drawLimitedLineStringMode';
import { getId } from 'utils/formHandlers';
import { translate } from 'utils/translate';

export const DEFAULT_VESSEL_LOA = 20;
export const DEFAULT_VESSEL_BEAM = 3;
export const PADGE_LIMIT = 30;
export const TOOLTIP_OFFSET = 10;
export const TRACK_UNUSED_TABS = false;
export const OPRN_PROFILE_WITHOUT_SEARCH = true;
export const LONG_SEARCH_TIME = 30;
export const MENUS = [
    'search',
    'layersMenu',
    'drawingMenu',
    'favouritMenu',
    'inspectTransit',
    'playbackTransit',
    'runTime',
    'highlight',
    'transitList',
    'gridMenu',
    'chartMenu',
    'profileMenu',
    'playbackMenu',
    'plansMenu',
];
export const MOVING_VESSEL_THRESHOLD = 0.257222;
export const OUTLINE_INTERVALS = [10, 30, 60, 180, 300];
export const SEARCH_LIMITS = [1, 5, 10, 20, 50, 100, 0]; //[10, 25, 50, 100, 0] old search limits;
export const DEFAULT_SEARCH_LAYOUT = 0;
export const MANAGERS = ['tagsManager', 'portsManager', 'searchesManager', 'commentsManager', 'usersManager'];
export const NAVIGATIONS = [
    'chart',
    'savedChart',
    'time',
    'grid',
    'profile',
    'tagsManager',
    'portsManager',
    'searchesManager',
    'commentsManager',
    'usersManager',
];
export const TAB_IDEL_TIMEOUT = 60 * 10 * 1000;
export const MAX_TAGS = 8;
export const SYSTEM_COLOR = '#8d00a6';
export const ACTIVE_COLOR = '#3b82f6';
export const TRACK_EVENT_COLOR = '#ff1717';
export const MARKING_LINE_COLOR = '#FFD700';
export const DRAWING_LINE_COLOR = '#FFD700';
// export const GRID_TAGS = ['user', 'system', 'positioning', 'analysis', 'profile'];
export const GRID_TAGS = ['user', 'analysis'];
export const PLAYBACK_SPEED = 10;
export const TIME_MODE_RANG_HOURS = 1;
export const PLAY_BACK_SPEEDS = [1, 2, 10, 20, 30];
export const OLD_SIGNAL_DURATION = 120; //sec

export const DRAWING_MODES = {
    pointer: {
        uuid: getId(),
        text: 'pointer',
        select: true,
        dragPan: true,
        handler: ViewMode,
        options: {},
    },
    measureLengthMode: {
        uuid: getId(),
        text: 'Measure Length',
        message: '',
        select: false,
        dragPan: true,
        handler: DrawLimitedLineStringMode,
        options: {
            modeConfig: {
                enableSnapping: true,
                allowSelfIntersection: false,
                snapToPointer: true,
                snapRadius: 20,
            },
        },
    },
    measureAreaMode: {
        uuid: getId(),
        text: 'Measure Area',
        message: 'Double click or press ENTER to end measure',
        select: false,
        dragPan: true,
        handler: DrawPolygonMode,
        options: {
            modeConfig: {
                enableSnapping: true,
                allowSelfIntersection: false,
                snapToPointer: true,
                snapRadius: 20,
            },
        },
    },
    drawPointMode: {
        uuid: getId(),
        text: 'Draw Point',
        message: '',
        handler: DrawPointMode,
        select: false,
        dragPan: true,
        options: {
            modeConfig: {
                enableSnapping: true,
                allowSelfIntersection: false,
                snapToPointer: true,
                snapRadius: 20,
            },
        },
    },
    drawLineStringMode: {
        uuid: getId(),
        text: 'Draw Line String',
        message: 'Double click or press ENTER to end drawing',
        handler: DrawLineStringMode,
        select: false,
        dragPan: true,
        options: {
            modeConfig: {
                enableSnapping: true,
                allowSelfIntersection: false,
                snapToPointer: true,
                snapRadius: 20,
            },
        },
    },
    drawPolygonMode: {
        uuid: getId(),
        text: 'Draw Polygon',
        message: 'Double click or press ENTER to end drawing',
        handler: DrawPolygonMode,
        select: false,
        dragPan: true,
        options: {
            modeConfig: {
                enableSnapping: true,
                allowSelfIntersection: false,
                snapToPointer: true,
                snapRadius: 20,
            },
        },
    },
    drawRectangleMode: {
        uuid: getId(),
        text: 'Draw Rectangle',
        message: '',
        handler: DrawRectangleMode,
        select: false,
        dragPan: true,
        options: {
            modeConfig: {
                enableSnapping: true,
                allowSelfIntersection: false,
                snapToPointer: true,
                snapRadius: 20,
            },
        },
    },

    // translateMode: {
    //     uuid: getId(),
    //     text: 'Move Feature',
    //     handler: TranslateMode,
    //     select: true,
    //     options: {
    //         lockY: false, // Lock movement along the Y-axis
    //         lockX: false, // Lock movement along the X-axis
    //     },
    // },
    // scaleMode: {
    //     uuid: getId(),
    //     text: 'Scale Feature',
    //     handler: ScaleMode,
    //     select: true,
    //     options: {
    //         minScale: 0.1, // Minimum scale factor
    //         maxScale: 10, // Maximum scale factor
    //     },
    // },

    drawCircleFromCenterMode: {
        uuid: getId(),
        text: 'Draw Circle from Center',
        message: '',
        handler: DrawCircleFromCenterMode,
        select: false,
        dragPan: true,
        options: {
            modeConfig: {
                enableSnapping: true,
                allowSelfIntersection: false,
                snapToPointer: true,
                snapRadius: 20,
            },
        },
    },
    labelMode: {
        uuid: getId(),
        text: 'Label a drawing object',
        message: '',
        select: true,
        dragPan: true,
        handler: ViewMode,
        options: {},
    },
    coordinateMode: {
        uuid: getId(),
        text: 'Coordinate label',
        message: '',
        handler: DrawPointMode,
        select: false,
        dragPan: true,
        options: {
            modeConfig: {
                enableSnapping: true,
                allowSelfIntersection: false,
                snapToPointer: true,
                snapRadius: 20,
            },
        },
    },
    modifyMode: {
        uuid: getId(),
        text: 'Edit drawing',
        message: '',
        handler: ModifyMode,
        select: true,
        dragPan: true,
        options: {
            modeConfig: {
                enableSnapping: true,
                allowSelfIntersection: false,
                snapToPointer: true,
                snapRadius: 20,
            },
        },
    },
    eraseMode: {
        uuid: getId(),
        text: 'Erase object',
        message: '',
        select: true,
        dragPan: true,
        handler: ViewMode,
        options: {},
    },
    saveDrawing: {
        uuid: getId(),
        text: 'Save all drawing objects',
        message: '',
        select: true,
        dragPan: true,
        handler: ViewMode,
        options: {},
    },
    // drawEllipseByBoundingBoxMode: {
    //     uuid: getId(),
    //     text: 'Draw Ellipse by Bounding Box',
    //     handler: DrawEllipseByBoundingBoxMode,
    //     options: {
    //         snappingRadius: 10,
    //     },
    // },
    // drawRectangleUsingThreePointsMode: {
    //     uuid: getId(),
    //     text: 'Draw Rectangle using Three Points',
    //     handler: DrawRectangleUsingThreePointsMode,
    //     options: {
    //         snappingRadius: 10,
    //     },
    // },
};

export const SWEPTPATH_COLOR = {
    colour: '#0ea5e9',
    opacity: 0.3,
    width: 2,
};
export const HIGHLIGHTED_SWEPTPATH_COLOR = {
    colour: '#FFD700',
    opacity: 0.3,
    width: 2,
};
export const HIGHLIGHTED_OUTLINE_INDEX_COLOR = {
    colour: '#FF0000',
    opacity: 1,
    width: 2,
};

export const DEFAULT_VIEW_MODE = 'live';
export const VIEW_MODE = (localStorage.getItem('viewMode') || DEFAULT_VIEW_MODE) as 'live' | 'chart';
//@ts-ignore
export const ALLOW_NAVIGATION = JSON.parse(localStorage.getItem('allowNavigation') || false);

export const DEFAULT_LAYOUT = {
    viewMode: VIEW_MODE,
    allowNavigation: ALLOW_NAVIGATION,
    openMenu: true,
    openTool: false,
    splashScreen: true,
    searchId: '',
    displayId: '',
    inspectId: '',
    playbackId: '',
    inspectTransit: '',
    playbackTransit: '',
    searching: false,
    inspectSelectedTime: null,
    playbackSelectedTime: null,
    sections: {
        system: {
            label: 'system',
            description: 'system manager',
            state: false,
            display: false,
            loading: false,
            navigate: false,
            temp: true,
            time: 0,
            disable: false,
            toolbarGroups: {},
            menus: {
                system: {
                    sections: {},
                    state: false,
                    data: {},
                    permissions: [],
                },

                systemConsole: {
                    sections: {},
                    state: false,
                    data: {},
                    permissions: [],
                },
            },
            tools: {},
        },

        chart: {
            label: 'chart',
            description: 'Analyse on a map',
            state: false,
            navigate: true,
            display: true,
            loading: false,
            temp: false,
            time: 3,
            disable: false,
            toolbarGroups: {
                replayTimeControl: 1,
                inspectTransit: 2,
                transitSearchControl: 3,
                chartDisplayOptions: 4,
                annotationTools: 5,
                sharingTool: 6,
            },
            menus: {
                searchMenu: {
                    label: 'Search',
                    group: 'transitSearchControl',
                    groupIndex: 0,
                    sections: {
                        loadFavourit: {
                            label: 'load favourite search',
                            display: true,
                            active: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },

                        tagsAndComments: {
                            label: 'tags and comments',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        dateRange: {
                            label: 'date range',
                            display: true,
                            active: true,
                            state: true,
                            data: {},
                            permissions: [],
                        },
                        transit: {
                            label: 'transit type',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        transitRoute: {
                            label: 'transit route',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        vessel: {
                            label: 'vessel',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        metOcean: {
                            label: 'metOcean',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        admin: {
                            label: 'admin',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: ['searchForAdminTags'],
                        },
                        saveFavourit: {
                            label: 'save search',
                            active: false,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                    },
                    display: true,
                    active: true,
                    state: true,
                    data: {},
                    permissions: [],
                },
                highlightMenu: {
                    label: 'highlight transits',
                    group: 'transitSearchControl',
                    groupIndex: 1,
                    sections: {
                        tagsAndComments: {
                            label: 'tags and comments',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        dateRange: {
                            label: 'date range',
                            display: true,
                            active: true,
                            state: true,
                            data: {},
                            permissions: [],
                        },
                        transit: {
                            label: 'transit',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        transitRoute: {
                            label: 'transit route',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        vessel: {
                            label: 'vessel',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        metOcean: {
                            label: 'metOcean',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        admin: {
                            label: 'admin',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: ['searchForAdminTags'],
                        },
                    },
                    display: true,
                    active: false,
                    state: false,
                    data: {},
                    permissions: [],
                },
                // favouritMenu: {
                //     label: 'favourite searches',
                //     group: 'transitSearchControl',
                //     groupIndex: 2,
                //     sections: {
                //         loadFavourit: {
                //             label: 'load favourite search',
                //             display: true,
                //             active: true,
                //             state: true,
                //             data: {},
                //             permissions: [],
                //         },
                //         saveFavourit: {
                //             label: 'save search',
                //             active: false,
                //             display: true,
                //             state: false,
                //             data: {},
                //             permissions: [],
                //         },
                //     },
                //     state: false,
                //     active: true,
                //     display: true,
                //     data: {},
                //     permissions: [],
                // },

                // chartMenu: {
                //     sections: {
                //         transitList: { selected: true, state: true, data: {} },
                //         inspect: { selected: false, state: false, data: {} },
                //     },
                //     state: true,
                //     data: {},
                // },

                layersMenu: {
                    label: 'chart display',
                    group: 'chartDisplayOptions',
                    groupIndex: 0,
                    sections: {
                        analysisAreas: {
                            label: 'analysis areas',
                            active: true,
                            display: true,
                            state: true,
                            data: {},
                            permissions: [],
                        },
                        manoeuvreInformation: {
                            label: 'manoeuvre information',
                            display: true,
                            active: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        enviromentalData: {
                            label: 'enviromental data',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        transitDisplay: {
                            label: 'transit display',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        metOceanData: {
                            label: 'metOcean data',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                    },
                    active: true,
                    display: true,
                    state: false,
                    data: {},
                    permissions: [],
                },
                plansMenu: {
                    label: 'select pilotage plan',
                    group: 'chartDisplayOptions',
                    groupIndex: 1,
                    sections: {},
                    state: false,
                    active: true,
                    display: true,
                    data: {},
                    permissions: [],
                },
                drawingMenu: {
                    group: null,
                    groupIndex: 1,
                    sections: {},
                    state: false,
                    active: false,
                    display: false,
                    data: {},
                    permissions: [],
                },
                inspectTransitMenu: {
                    label: 'inspect transit',
                    group: 'inspectTransit',
                    groupIndex: 0,
                    sections: {
                        inspectTransit: {
                            label: 'inspect transit',
                            active: false,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        editTransit: {
                            label: 'edit transit',
                            active: false,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        showAllTransits: {
                            label: 'show all transits',
                            active: false,
                            display: true,
                            state: true,
                            data: {},
                            permissions: [],
                        },
                        downloadTransit: {
                            label: 'download transit',
                            active: false,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },

                        transitDownloadSweptPathFile: {
                            label: 'download swept path',
                            active: false,
                            display: true,
                            state: false,
                            data: {},
                            permissions: ['downloadFiles'],
                        },
                    },
                    state: false, // used to opne or close menu
                    display: true, // used to render icon on toolbar // static by dev
                    active: false, // used to active menu icon on toolbar
                    data: {},
                    permissions: [],
                },
            },
            tools: {
                // changeTime: {
                //     label: 'replay time',
                //     group: 'replayTimeControl',
                //     groupIndex: 0,
                //     state: false,
                //     active: true,
                //     display: true,
                //     sections: {},
                //     permissions: [],
                // },
                measureLength: {
                    label: 'measure length',
                    group: 'annotationTools',
                    groupIndex: 0,
                    state: false,
                    active: true,
                    display: true,
                    sections: {},
                    permissions: [],
                },
                measureArea: {
                    label: 'measure area',
                    group: 'annotationTools',
                    groupIndex: 1,
                    state: false,
                    active: true,
                    display: true,
                    sections: {},
                    permissions: [],
                },
                drawing: {
                    label: 'drawing tools',
                    group: 'annotationTools',
                    groupIndex: 2,
                    state: false,
                    active: true,
                    display: true,
                    sections: Object.keys(DRAWING_MODES)
                        .filter((key) => {
                            return key !== 'pointer' && !key.includes('measure');
                        })
                        .reduce((acc, key) => {
                            acc[key] = {
                                label: DRAWING_MODES[key].text,
                                state: false,

                                active: true,
                                display: true,
                                data: {},
                                permissions: [],
                            };
                            return acc;
                        }, {}),
                    permissions: [],
                },
                eraseAll: {
                    label: 'erase all',
                    group: 'annotationTools',
                    groupIndex: 3,
                    state: false,
                    active: true,
                    display: true,
                    sections: {},
                    permissions: [],
                },
                copyChart: {
                    label: 'share transits',
                    group: 'sharingTool',
                    groupIndex: 0,
                    state: false,
                    active: false,
                    display: true,
                    sections: {},
                    permissions: [],
                },
            },
            tab: 'chart',
            data: {},
            mode: 'search',
        },
        grid: {
            label: 'grid',
            description: 'Analyse in a table',
            state: false,
            navigate: true,
            loading: false,
            display: true,
            disable: false,
            temp: false,
            time: 2,
            toolbarGroups: {
                replayTimeControl: 1,
                inspectTransit: 2,
                transitSearchControl: 3,
                gridDisplayOptions: 4,
                sharingTool: 5,
            },
            menus: {
                // gridMenu: {
                //     sections: {
                //         search: { selected: true, state: true, data: {} },
                //         highlight: { selected: false, state: true, data: {} },
                //         inspect: { selected: false, state: false, data: {} },
                //     },
                //     state: true,
                //     data: {},
                // },
                searchMenu: {
                    label: 'Search',
                    group: 'transitSearchControl',
                    groupIndex: 0,
                    sections: {
                        loadFavourit: {
                            label: 'load favourite search',
                            display: true,
                            active: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        tagsAndComments: {
                            label: 'tags and comments',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        dateRange: {
                            label: 'date range',
                            display: true,
                            active: true,
                            state: true,
                            data: {},
                            permissions: [],
                        },
                        transit: {
                            label: 'transit type',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        transitRoute: {
                            label: 'transit route',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        vessel: {
                            label: 'vessel',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        metOcean: {
                            label: 'metOcean',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        admin: {
                            label: 'admin',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: ['searchForAdminTags'],
                        },
                        saveFavourit: {
                            label: 'save search',
                            active: false,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                    },
                    display: true,
                    active: true,
                    state: true,
                    data: {},
                    permissions: [],
                },
                highlightMenu: {
                    label: 'highlight transits',
                    group: 'transitSearchControl',
                    groupIndex: 1,
                    sections: {
                        tagsAndComments: {
                            label: 'tags and comments',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        dateRange: {
                            label: 'date range',
                            display: true,
                            active: true,
                            state: true,
                            data: {},
                            permissions: [],
                        },
                        transit: {
                            label: 'transit',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        transitRoute: {
                            label: 'transit route',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        vessel: {
                            label: 'vessel',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        metOcean: {
                            label: 'metOcean',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        admin: {
                            label: 'admin',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: ['searchForAdminTags'],
                        },
                    },
                    display: true,
                    active: false,
                    state: false,
                    data: {},
                    permissions: [],
                },
                // favouritMenu: {
                //     label: 'favourite searches',
                //     group: 'transitSearchControl',
                //     groupIndex: 2,
                //     sections: {
                //         loadFavourit: {
                //             label: 'load favourite search',
                //             display: true,
                //             active: true,
                //             state: true,
                //             data: {},
                //             permissions: [],
                //         },
                //         saveFavourit: {
                //             label: 'save search',
                //             active: true,
                //             display: true,
                //             state: false,
                //             data: {},
                //             permissions: [],
                //         },
                //     },
                //     state: false,
                //     active: true,
                //     display: true,
                //     data: {},
                //     permissions: [],
                // },
                inspectTransitMenu: {
                    label: 'inspect transit',
                    group: 'inspectTransit',
                    groupIndex: 0,
                    sections: {
                        inspectTransit: {
                            label: 'inspect transit',
                            active: false,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        editTransit: {
                            label: 'edit transit',
                            active: false,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        showAllTransits: {
                            label: 'show all transits',
                            active: false,
                            display: true,
                            state: true,
                            data: {},
                            permissions: [],
                        },
                        downloadTransit: {
                            label: 'download transit',
                            active: false,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },

                        transitDownloadSweptPathFile: {
                            label: 'download swept path',
                            active: false,
                            display: true,
                            state: false,
                            data: {},
                            permissions: ['downloadFiles'],
                        },
                    },
                    state: false, // used to opne or close menu
                    display: true, // used to render icon on toolbar // static by dev
                    active: false, // used to active menu icon on toolbar
                    data: {},
                    permissions: [],
                },
            },
            tools: {
                // changeTime: {
                //     label: 'replay time',
                //     group: 'replayTimeControl',
                //     groupIndex: 0,
                //     state: false,
                //     active: true,
                //     display: true,
                //     sections: {},
                //     permissions: [],
                // },
                gridSettings: {
                    label: 'grid settings',
                    group: 'gridDisplayOptions',
                    groupIndex: 0,
                    state: false,
                    display: true,
                    active: true,
                    sections: {},
                    permissions: [],
                },
                exportGrid: {
                    label: 'export search statistics',
                    group: 'gridDisplayOptions',
                    groupIndex: 1,
                    state: false,
                    display: true,
                    active: false,
                    sections: {},
                    permissions: [],
                },
                // tagsGrid: {
                //     label: 'tags and comments',
                //     group: 'gridDisplayOptions',
                //     groupIndex: 2,
                //     state: false,
                //     display: true,
                //     active: false,
                //     sections: {},
                //     permissions: [],
                // },
            },
            tab: 'grid',
            data: {},
            mode: 'search',
        },
        profile: {
            label: 'profile',
            description: 'Analyse vs a plan',
            state: false,
            loading: false,
            navigate: true,
            disable: false,
            display: true,
            temp: false,
            time: 1,
            toolbarGroups: {
                replayTimeControl: 1,
                profileOptions: 2,
                transitSearchControl: 3,
                pilotagePlanSelector: 4,
                profileDataExport: 5,
            },
            menus: {
                searchMenu: {
                    label: 'Search',
                    group: 'transitSearchControl',
                    groupIndex: 0,
                    sections: {
                        loadFavourit: {
                            label: 'load favourite search',
                            display: true,
                            active: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        tagsAndComments: {
                            label: 'tags and comments',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        dateRange: {
                            label: 'date range',
                            display: true,
                            active: true,
                            state: true,
                            data: {},
                            permissions: [],
                        },
                        transit: {
                            label: 'transit type',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        transitRoute: {
                            label: 'transit route',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        vessel: {
                            label: 'vessel',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        metOcean: {
                            label: 'metOcean',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        admin: {
                            label: 'admin',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: ['searchForAdminTags'],
                        },
                        saveFavourit: {
                            label: 'save search',
                            active: false,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                    },
                    display: true,
                    active: true,
                    state: true,
                    data: {},
                    permissions: [],
                },
                // profileMenu: {
                //     sections: {
                //         search: { active: true, state: true, data: {} },
                //     },
                //     state: false,
                //     data: {},
                // },

                highlightMenu: {
                    label: 'highlight transits',
                    group: 'transitSearchControl',
                    groupIndex: 1,
                    sections: {
                        tagsAndComments: {
                            label: 'tags and comments',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        dateRange: {
                            label: 'date range',
                            display: true,
                            active: true,
                            state: true,
                            data: {},
                            permissions: [],
                        },
                        transit: {
                            label: 'transit',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        transitRoute: {
                            label: 'transit route',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        vessel: {
                            label: 'vessel',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        metOcean: {
                            label: 'metOcean',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        admin: {
                            label: 'admin',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: ['searchForAdminTags'],
                        },
                    },
                    display: true,
                    active: false,
                    state: false,
                    data: {},
                    permissions: [],
                },
                // favouritMenu: {
                //     label: 'favourite searches',
                //     group: 'transitSearchControl',
                //     groupIndex: 2,
                //     sections: {
                //         loadFavourit: {
                //             label: 'load favourite search',
                //             display: true,
                //             active: true,
                //             state: true,
                //             data: {},
                //             permissions: [],
                //         },
                //         saveFavourit: {
                //             label: 'save search',
                //             active: true,
                //             display: true,
                //             state: false,
                //             data: {},
                //             permissions: [],
                //         },
                //     },
                //     state: false,
                //     active: true,
                //     display: true,
                //     data: {},
                //     permissions: [],
                // },
                plansMenu: {
                    label: 'select pilotage plan',
                    group: 'pilotagePlanSelector',
                    groupIndex: 3,
                    sections: {},
                    state: false,
                    active: true,
                    display: true,
                    data: {},
                    permissions: [],
                },
            },
            tools: {
                changeTime: {
                    label: 'replay time',
                    group: 'replayTimeControl',
                    groupIndex: 0,
                    state: false,
                    active: true,
                    display: true,
                    sections: {},
                    permissions: [],
                },
                exportAnalysis: {
                    label: 'export profile data',
                    group: 'profileDataExport',
                    groupIndex: 0,
                    state: true,
                    active: false,
                    display: true,
                    sections: {},
                    permissions: [],
                },
                updateAnalysis: {
                    label: 'Update analysis',
                    group: 'profileOptions',
                    groupIndex: 1,
                    state: true,
                    active: false,
                    display: true,
                    sections: {},
                    permissions: [],
                },
            },
            tab: 'profile',
            data: {},
            permissions: [],
            mode: 'search',
        },
        time: {
            label: 'vessel list',
            description: 'replay AIS data',
            state: false,
            display: false,
            loading: false,
            navigate: false,
            temp: VIEW_MODE !== 'live',
            time: 0,
            disable: false,
            toolbarGroups: {
                replayTimeControl: 1,
                chartDisplayOptions: 2,
                annotationTools: 3,
            },
            menus: {
                timeMenu: {
                    label: 'Vessel list',
                    group: 'chartDisplayOptions',
                    groupIndex: 2,
                    sections: {
                        transitVessels: {
                            label: 'list transit vessels',
                            display: true,
                            active: true,
                            state: true,
                            data: {},
                            permissions: [],
                        },
                        portVessels: {
                            label: 'list port vessels',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        otherVessels: {
                            label: 'list other vessels',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                    },
                    display: true,
                    active: true,
                    state: true,
                    data: {},
                    permissions: [],
                },
                layersMenu: {
                    label: 'chart display',
                    group: 'chartDisplayOptions',
                    groupIndex: 0,
                    sections: {
                        analysisAreas: {
                            label: 'analysis areas',
                            active: true,
                            display: true,
                            state: true,
                            data: {},
                            permissions: [],
                        },
                        manoeuvreInformation: {
                            label: 'manoeuvre information',
                            display: true,
                            active: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        enviromentalData: {
                            label: 'enviromental data',
                            active: true,
                            display: false,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        transitDisplay: {
                            label: 'transit display',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        metOceanData: {
                            label: 'metOcean data',
                            active: true,
                            display: false,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                    },
                    active: true,
                    display: true,
                    state: false,
                    data: {},
                    permissions: [],
                },
                drawingMenu: {
                    group: null,
                    groupIndex: 1,
                    sections: {},
                    state: false,
                    active: false,
                    display: false,
                    data: {},
                    permissions: [],
                },
                plansMenu: {
                    label: 'select pilotage plan',
                    group: 'chartDisplayOptions',
                    groupIndex: 1,
                    sections: {},
                    state: false,
                    active: true,
                    display: true,
                    data: {},
                    permissions: [],
                },
            },
            tools: {
                timeOptions: {
                    label: 'replay time',
                    group: 'replayTimeControl',
                    groupIndex: 0,
                    state: false,
                    active: true,
                    display: true,
                    sections: {
                        changeTime: {
                            label: 'change time',
                            state: false,
                            active: true,
                            display: true,
                            data: {},
                            permissions: [],
                        },
                        hourEarlier: {
                            label: '1 hour earlier',
                            state: false,
                            active: true,
                            display: true,
                            data: {},
                            permissions: [],
                        },
                        hourLater: {
                            label: '1 hour later',
                            state: false,
                            active: true,
                            display: true,
                            data: {},
                            permissions: [],
                        },
                    },
                    permissions: [],
                },
                measureLength: {
                    label: 'measure length',
                    group: 'annotationTools',
                    groupIndex: 0,
                    state: false,
                    active: true,
                    display: true,
                    sections: {},
                    permissions: [],
                },
                measureArea: {
                    label: 'measure area',
                    group: 'annotationTools',
                    groupIndex: 1,
                    state: false,
                    active: true,
                    display: true,
                    sections: {},
                    permissions: [],
                },
                drawing: {
                    label: 'drawing tools',
                    group: 'annotationTools',
                    groupIndex: 2,
                    state: false,
                    active: true,
                    display: true,
                    sections: Object.keys(DRAWING_MODES)
                        .filter((key) => {
                            return key !== 'pointer' && !key.includes('measure');
                        })
                        .reduce((acc, key) => {
                            acc[key] = {
                                label: DRAWING_MODES[key].text,

                                state: false,
                                active: true,
                                display: true,
                                data: {},
                                permissions: [],
                            };
                            return acc;
                        }, {}),
                    permissions: [],
                },
                eraseAll: {
                    label: 'erase all',
                    group: 'annotationTools',
                    groupIndex: 3,
                    state: false,
                    active: true,
                    display: true,
                    sections: {},
                    permissions: [],
                },
            },
            tab: 'time',
            data: {
                startTime: null,
                endTime: null,
            },
            permissions: [],
            mode: 'live',
        },
        playback: {
            label: 'replay transit',
            description: 'replay transit',
            state: false,
            display: false,
            loading: false,
            navigate: false,
            disable: false,
            temp: true,
            time: 0,
            toolbarGroups: {
                replayTimeControl: 1,
                chartDisplayOptions: 2,
                annotationTools: 3,
            },
            menus: {
                playbackMenu: {
                    label: 'Vessel list',
                    group: 'chartDisplayOptions',
                    groupIndex: 2,
                    sections: {
                        transitVessels: {
                            label: 'transit vessels',
                            display: false,
                            active: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        otherTransits: {
                            label: 'nearby transits',
                            display: true,
                            active: true,
                            state: true,
                            data: {},
                            permissions: [],
                        },
                        portVessels: {
                            label: 'list port vessels',
                            display: true,
                            active: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        otherVessels: {
                            label: 'list other vessels',
                            display: true,
                            active: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                    },
                    display: true,
                    active: true,
                    state: true,
                    data: {},
                    permissions: [],
                },
                layersMenu: {
                    label: 'chart display',
                    group: 'chartDisplayOptions',
                    groupIndex: 0,
                    sections: {
                        analysisAreas: {
                            label: 'analysis areas',
                            active: true,
                            display: true,
                            state: true,
                            data: {},
                            permissions: [],
                        },
                        manoeuvreInformation: {
                            label: 'manoeuvre information',
                            display: true,
                            active: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        enviromentalData: {
                            label: 'enviromental data',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        transitDisplay: {
                            label: 'transit display',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                        metOceanData: {
                            label: 'metOcean data',
                            active: true,
                            display: true,
                            state: false,
                            data: {},
                            permissions: [],
                        },
                    },
                    active: true,
                    display: true,
                    state: false,
                    data: {},
                    permissions: [],
                },
                plansMenu: {
                    label: 'select pilotage plan',
                    group: 'chartDisplayOptions',
                    groupIndex: 1,
                    sections: {},
                    state: false,
                    active: true,
                    display: true,
                    data: {},
                    permissions: [],
                },
                drawingMenu: {
                    sections: {},
                    group: null,
                    groupIndex: 3,
                    state: false,
                    active: false,
                    display: false,
                    data: {},
                    permissions: [],
                },
            },
            tools: {
                changeTime: {
                    label: 'replay time',
                    group: 'replayTimeControl',
                    groupIndex: 0,
                    state: false,
                    active: true,
                    display: true,
                    sections: {},
                    permissions: [],
                },
                measureLength: {
                    label: 'measure length',
                    group: 'annotationTools',
                    groupIndex: 0,
                    state: false,
                    active: true,
                    display: true,
                    sections: {},
                    permissions: [],
                },
                measureArea: {
                    label: 'measure area',
                    group: 'annotationTools',
                    groupIndex: 1,
                    state: false,
                    active: true,
                    display: true,
                    sections: {},
                    permissions: [],
                },
                drawing: {
                    label: 'drawing tools',
                    group: 'annotationTools',
                    groupIndex: 2,
                    state: false,
                    active: true,
                    display: true,
                    sections: Object.keys(DRAWING_MODES)
                        .filter((key) => {
                            return key !== 'pointer' && !key.includes('measure');
                        })
                        .reduce((acc, key) => {
                            acc[key] = {
                                label: DRAWING_MODES[key].text,

                                state: false,
                                active: true,
                                display: true,
                                data: {},
                                permissions: [],
                            };
                            return acc;
                        }, {}),
                    permissions: [],
                },
                eraseAll: {
                    label: 'erase all',
                    group: 'annotationTools',
                    groupIndex: 3,
                    state: false,
                    active: true,
                    display: true,
                    sections: {},
                    permissions: [],
                },
            },
            tab: 'playback',
            data: {},
            permissions: [],
            mode: 'playback',
        },

        replay: {
            label: 'Replay',
            description: 'AIS at any time',
            state: false,
            navigate: false,
            loading: false,
            disable: false,
            display: true,
            temp: false,
            time: 0,
            toolbarGroups: {},
            menus: {},
            tools: {},
            tab: 'replay',
            data: {},
            permissions: [],
            mode: 'playback',
        },
        aiChat: {
            label: 'Ask TA Genie',
            description: 'TransitAnalyst AI trial',
            state: false,
            navigate: true,
            loading: false,
            disable: false,
            display: true,
            temp: false,
            checkPermission: ['openAIchat'],
            time: 0,
            toolbarGroups: {},
            menus: {},
            tools: {},
            tab: 'ai',
            data: {},
            permissions: [],
            mode: 'all',
        },
        metOceanChart: {
            label: 'metOcean chart',
            state: false,
            navigate: false,
            disable: false,
            display: false,
            loading: false,
            temp: true,
            time: 0,
            toolbarGroups: {},
            menus: {},
            tools: {},
            tab: 'metOceanChart',
            data: {},
            permissions: [],
            mode: 'search',
        },
        tagsManager: {
            label: 'tags',
            description: 'manage system tags',
            state: false,
            navigate: true,
            disable: false,
            display: false,
            loading: false,
            temp: true,
            time: 0,
            toolbarGroups: {},
            menus: {},
            tools: {},
            tab: 'tagManager',
            data: {},
            permissions: [],
            mode: 'manage',
        },
        portsManager: {
            label: 'port manager',
            description: 'manage system ports',
            state: false,
            navigate: true,
            disable: false,
            loading: false,
            display: false,
            temp: true,
            time: 0,
            toolbarGroups: {},
            menus: {},
            tools: {},
            tab: 'portManager',
            data: {},
            permissions: [],
            mode: 'manage',
        },
        searchesManager: {
            label: 'searches',
            description: 'manage saved searches',
            state: false,
            navigate: true,
            disable: false,
            display: false,
            loading: false,
            temp: true,
            time: 0,
            toolbarGroups: {},
            menus: {},
            tools: {},
            tab: 'searchManager',
            data: {},
            permissions: [],
            mode: 'manage',
        },
        commentsManager: {
            label: 'comments',
            description: 'manage user comments',
            state: false,
            navigate: true,
            disable: false,
            display: false,
            loading: false,
            temp: true,
            time: 0,
            toolbarGroups: {},
            menus: {},
            tools: {},
            tab: 'commentManager',
            data: {},
            permissions: [],
            mode: 'manage',
        },
        usersManager: {
            label: 'user',
            description: 'manage user',
            state: false,
            navigate: true,
            disable: false,
            display: false,
            loading: false,
            temp: true,
            time: 0,
            toolbarGroups: {},
            menus: {},
            tools: {},
            tab: 'userManager',
            data: {},
            permissions: [],
            mode: 'manage',
        },
    },
};

export const DEFAULT_GRID_SETTINGS = {
    tags: GRID_TAGS,
    type: 'default',
    use_short_titles: true,
    columns: [
        {
            uuid: '9c3a754c-08a1-4fdf-b304-5e6fb8933425',
            key: 'start_utc',
            label: 'start',
            status: true,
            order: true,
            orderDirection: 'desc',
            orderType: 'date',
            size: 2,
            meta_data: {},
        },
        {
            uuid: 'a145c42a-c986-4a25-b0af-8a4c050c9133',
            key: 'end_utc',
            label: 'end',
            status: false,
            order: true,
            orderDirection: 'desc',
            orderType: 'date',
            size: 2,
            meta_data: {},
        },
        {
            uuid: 'd6e2718e-c4f5-433f-adad-ecd697af9c65',
            key: 'direction',
            label: 'type',
            status: true,
            order: true,
            orderDirection: 'asc',
            orderType: 'string',
            size: 2,
            meta_data: {},
        },
        {
            uuid: '8c1752ab-ad52-461a-b4a2-7534d5f10dc6',
            key: 'vessel.name',
            label: 'name',
            status: true,
            order: true,
            orderDirection: 'asc',
            orderType: 'string',
            size: 4,
            meta_data: {},
        },
        {
            uuid: 'f89f32dd-a84d-4db4-a757-4e5e66597479',
            key: 'vessel.loa_m',
            label: 'loa',
            status: true,
            order: true,
            orderDirection: 'desc',
            orderType: 'number',
            size: 1,
            meta_data: {},
        },
        {
            uuid: '70ebb1fc-2af1-41f7-9f91-0166394b62bf',
            key: 'vessel.beam_m',
            label: 'beam',
            status: true,
            order: true,
            orderDirection: 'desc',
            orderType: 'number',
            size: 1,
            meta_data: {},
        },
        {
            uuid: '06727d4d-ec6c-4e1a-86f5-6b637618bb94',
            key: 'draft_m',
            label: 'draft',
            status: true,
            order: true,
            orderDirection: 'desc',
            orderType: 'number',
            size: 1,
            meta_data: {},
        },
        {
            uuid: '5ab1e550-439c-4e9e-aae0-935d4983bc6a',
            key: 'comments',
            label: 'comments',
            status: true,
            order: false,
            orderDirection: 'desc',
            orderType: 'number',
            size: 2,
            meta_data: {},
        },
        {
            uuid: '4b6c318a-0941-4f00-8c4a-d0529d944b1c',
            key: 'tags',
            label: 'tags',
            status: true,
            order: false,
            orderDirection: 'desc',
            orderType: 'number',
            size: 9,
            meta_data: {},
        },
    ],
};

export const USER_ROLES = [
    {
        description: 'Download transits',
        function: 'downloadFiles',
        forAdmin: false,
    },
    {
        description: 'Identify transits',
        function: 'identifyTransits',
        help: 'Default identify transit setting for this user in this port',
        forAdmin: false,
    },
    {
        description: 'AI trial',
        function: 'openAIchat',
        forAdmin: false,
    },
    {
        description: 'Toggle identification',
        function: 'obscureDisplay',
        help: 'Can the user change his/her identify transit setting?',
        forAdmin: false,
    },
    {
        description: 'Search for admin tags',
        function: 'searchForAdminTags',
        forAdmin: false,
    },
    { description: 'Tags admin', function: 'tagsAdmin', forAdmin: true },
    { description: 'Users admin', function: 'usersAdmin', forAdmin: true },
    {
        description: 'Comments admin',
        function: 'commentsAdmin',
        forAdmin: true,
    },
    {
        description: 'Searches admin',
        function: 'searchsAdmin',
        forAdmin: true,
    },
];

export const YES_AND_NO = [
    { value: 'true', label: translate('yes') },
    { value: 'false', label: translate('no') },
];
export const YES_AND_NO_BOOLAN = [
    { value: true, label: translate('yes') },
    { value: false, label: translate('no') },
];

export const USER_TYPE = [
    { value: 'systemAdministrator', label: translate('yes') },
    { value: 'editor', label: translate('no') },
];

export const USER_TYPES = [
    { name: 'Guest', id: 'guest', rules: [] },
    { name: 'Pilot', id: 'editor', rules: ['downloadFiles', 'identifyTransits', 'obscureDisplay'] },
    {
        name: 'Port manager',
        id: 'portManager',
        rules: [
            'downloadFiles',
            'identifyTransits',
            'obscureDisplay',
            'searchForAdminTags',
            'manageUsers',
            'tagsAdmin',
            'commentsAdmin',
            'searchsAdmin',
        ],
    },
    {
        name: translate('System administrator'),
        id: 'systemAdministrator',
        rules: [
            'downloadFiles',
            'identifyTransits',
            'obscureDisplay',
            'searchForAdminTags',
            'manageUsers',
            'tagsAdmin',
            'usersAdmin',
            'commentsAdmin',
            'searchsAdmin',
        ],
    },
];

export const COLOR_RANGES = {
    warm: [
        [255, 255, 178],
        [254, 217, 118],
        [254, 178, 76],
        [253, 141, 60],
        [240, 59, 32],
        [189, 0, 38],
    ],
    cool: [
        [247, 252, 253],
        [224, 236, 244],
        [191, 211, 230],
        [158, 188, 218],
        [140, 150, 198],
        [136, 86, 167],
    ],
    viridis: [
        [68, 1, 84],
        [59, 82, 139],
        [33, 145, 140],
        [94, 201, 98],
        [253, 231, 37],
        [255, 255, 217],
    ],
    inferno: [
        [0, 0, 4],
        [31, 12, 72],
        [85, 15, 109],
        [136, 34, 106],
        [186, 54, 85],
        [235, 138, 46],
    ],
    plasma: [
        [12, 7, 134],
        [73, 3, 171],
        [125, 3, 168],
        [177, 40, 129],
        [224, 91, 85],
        [248, 186, 107],
    ],
    magma: [
        [0, 0, 4],
        [28, 16, 68],
        [79, 18, 123],
        [129, 37, 129],
        [181, 54, 122],
        [244, 109, 67],
    ],
    sunset: [
        [255, 247, 236],
        [254, 232, 200],
        [253, 212, 158],
        [253, 187, 132],
        [252, 141, 89],
        [227, 74, 51],
    ],
    rainbow: [
        [150, 0, 90],
        [0, 0, 200],
        [0, 255, 255],
        [0, 200, 0],
        [255, 255, 0],
        [255, 0, 0],
    ],
};

export const TAG_SHARED_TYPES = [
    { value: 'public', label: 'public' },
    { value: 'private', label: 'private' },
];

export const TAG_TYPES = [
    { value: 'public', label: 'public' },
    { value: 'private', label: 'private' },
    { value: 'analysis', label: 'analysis' },
    { value: 'positioning', label: 'positioning' },
];

export const ADMIN_TAG_TYPES = [
    { value: 'public', label: 'public' },
    { value: 'private', label: 'private' },
    { value: 'system', label: 'system' },
    { value: 'admin', label: 'admin' },
    { value: 'type', label: 'type' },
    { value: 'analysis', label: 'analysis' },
    { value: 'positioning', label: 'positioning' },
];

export const LAYERS = {
    drawingLayer: {
        group: 'drawing',
        name: 'drawingLayer',
        drawIndex: 200,
        clickIndex: 200,
        uuid: '5932facb-987b-4be2-8d45-4deee0f8f05d',
    },
    sweptPath: {
        group: 'features',
        name: 'sweptPath',
        drawIndex: 101,
        clickIndex: 101,
        uuid: 'e0b03c99-40ff-4b19-a90f-1739c2d263b3',
    },
    vesselOutline: {
        group: 'features',
        name: 'vesselOutline',
        drawIndex: 103,
        clickIndex: 103,
        uuid: 'f8b97e84-e193-4ec4-87ef-1eeb842b5e72',
    },
    playbackVesselOutline: {
        group: 'vesselInfo',
        name: 'playbackVesselOutline',
        drawIndex: 103,
        clickIndex: 103,
        uuid: '397ef14a-9313-4a8b-b076-aa19217a089d',
    },
    timeVesselOutline: {
        group: 'vesselInfo',
        name: 'timeVesselOutline',
        drawIndex: 103,
        clickIndex: 103,
        uuid: '3c321f1c-4aa2-422d-bffe-f6cfad9bce9f',
    },
    transitTrack: {
        group: 'vesselInfo',
        name: 'transitTrack',
        drawIndex: 102,
        clickIndex: 102,
        uuid: 'ed9f84c5-4c11-4f99-9209-bd3a7a53949f',
    },
    markingLayer: {
        group: 'none',
        name: 'markingLayer',
        drawIndex: 110,
        clickIndex: 29,
        uuid: 'f12921f3-bce3-4121-9fbc-1ab0b12bc916',
    },
    transitTrackEvents: {
        group: 'trackEvent',
        name: 'transitTrackEvents',
        drawIndex: 106,
        clickIndex: 106,
        uuid: '554da687-bcde-4a7c-9bf2-e99ebec82148',
    },
    vesselTrack: {
        group: 'vesselInfo',
        name: 'vesselTrack',
        drawIndex: 104,
        clickIndex: 104,
        uuid: 'cb700784-ccc6-417e-97f7-79fb4aa28bfd',
    },
    vesselTrackHighlightPoints: {
        group: 'vesselInfo',
        name: 'vesselTrackHighlightPoints',
        drawIndex: 105,
        clickIndex: 105,
        uuid: '8900af0f-0569-4007-805d-33bbae835975',
    },
    vesselTrackPoints: {
        group: 'trackEvent',
        name: 'vesselTrackPoints',
        drawIndex: 105,
        clickIndex: 105,
        uuid: '359d4183-c2ba-4606-a832-a34b20fb9994',
    },
    // heatmap: {
    //     group: 'aggregationLayers',
    //     name: 'heatmap',
    //     drawIndex: 50,
    //     clickIndex: 50,
    //     options: {
    //         radiusPixels: 50,
    //         intensity: 2,
    //         threshold: 0.05,
    //         colorDomain: [0.02, 5],
    //         aggregation: 'SUM',
    //         colorRange: 'warm',
    //         groupBy: 'coordinates',
    //     },
    //     uuid: 'fd4b3763-ad4a-4b6f-bc61-22d70df1bb68',
    // },
    // screenGrid: {
    //     group: 'aggregationLayers',
    //     name: 'screen grid',
    //     drawIndex: 51,
    //     clickIndex: 51,
    //     options: { cellSizePixels: 10, colorRange: 'warm', opacity: 0.8, groupBy: 'coordinates' },
    //     uuid: '88843415-db57-4e0d-a141-6bd8e8869b6f',
    // },
    monitoringArea: {
        group: 'portAreas',
        style: 'features',
        withPlan: false,
        drawIndex: 0,
        clickIndex: 0,
        name: 'monitoringAreaLayer',
        uuid: 'ee1eb409-cc37-48c8-a9d8-3e8cb2b59c12',
    },
    portArea: {
        group: 'portAreas',
        style: 'features',
        drawIndex: 12,
        clickIndex: 12,
        name: 'portAreaLayer',
        uuid: 'a86a1fd7-4f95-4d84-87e2-2088b9a9bd4e',
    },
    displayArea: {
        group: 'portAreas',
        style: 'display_areas',
        withPlan: false,
        drawIndex: 13,
        clickIndex: 13,
        name: 'displayAreaLayer',
        uuid: '9c1a6d86-163f-4c56-9d58-baf73db5d92e',
    },
    swing: {
        group: 'portAreas',
        style: 'backmanoeuvre_areas',
        withPlan: false,
        drawIndex: 14,
        clickIndex: 14,
        name: 'swingLayer',
        uuid: 'f67be071-71cc-41fc-927d-f43a99b7ce84',
    },
    manoeuvre: {
        group: 'portAreas',
        style: 'manoeuvre_areas',
        withPlan: true,
        drawIndex: 15,
        clickIndex: 15,
        name: 'manoeuvreLayer',
        uuid: 'fbdad7d4-3087-491d-b9a5-c99d3060e802',
    },
    channel: {
        group: 'portAreas',
        style: 'channel_areas',
        withPlan: false,
        drawIndex: 16,
        clickIndex: 16,
        name: 'channelLayer',
        uuid: '013244a7-fffb-4146-a0af-78e13cf3db43',
    },
    regionAreas: {
        group: 'portAreas',
        style: 'region_areas',
        withPlan: false,
        drawIndex: 17,
        clickIndex: 17,
        name: 'regionAreasLayer',
        uuid: 'ec522fe6-3ee8-44e8-b8aa-180c68c68da8',
    },
    corridorAreas: {
        group: 'portAreas',
        style: 'corridor_areas',
        withPlan: false,
        drawIndex: 18,
        clickIndex: 18,
        name: 'corridorLayer',
        uuid: '5e28444f-7f96-43ad-9353-cbfc2c135d41',
    },
    berthLine: {
        group: 'portAreas',
        style: 'fender_lines',
        withPlan: false,
        drawIndex: 19,
        clickIndex: 19,
        name: 'berthLayer',
        uuid: 'ec6e86b8-20c6-4d47-bc8c-becfaeb04b40',
    },
    berth: {
        group: 'portAreas',
        style: 'berth_areas',
        withPlan: false,
        drawIndex: 20,
        clickIndex: 20,
        name: 'berthLayer',
        uuid: 'db634f78-63d0-4b39-b738-bb6469277c9e',
    },
    anchorage: {
        group: 'portAreas',
        style: 'anchorage_areas',
        withPlan: false,
        drawIndex: 21,
        clickIndex: 21,
        name: 'anchorageLayer',
        uuid: '9c9e7552-03bc-4049-8ee7-c59ea5d99a72',
    },
    pilotBoardingGround: {
        group: 'portAreas',
        style: 'pilotboarding_areas',
        withPlan: false,
        drawIndex: 22,
        clickIndex: 22,
        name: 'pilotBoardingGroundLayer',
        uuid: '0b3a5d41-87ae-41c3-9c04-d504b56e930d',
    },
    reservedAreas: {
        group: 'portAreas',
        style: 'reserved_areas',
        withPlan: true,
        drawIndex: 23,
        clickIndex: 23,
        name: 'reservedAreasLayer',
        uuid: 'f8251071-cd45-45b6-85f6-ecc647503e39',
    },
    noGoAreas: {
        group: 'portAreas',
        style: 'nogo_areas',
        withPlan: true,
        drawIndex: 24,
        clickIndex: 24,
        name: 'noGoAreasLayer',
        uuid: '8c56ae9a-5220-40fc-855e-c374f2d03c6d',
    },
    xtd: {
        group: 'portAreas',
        style: 'xtd_areas',
        withPlan: true,
        drawIndex: 105,
        clickIndex: 25,
        name: 'xtdLayer',
        uuid: '77f7c97c-8ff4-47a5-9a12-c062b6322b76',
    },
    route: {
        group: 'portAreas',
        style: 'route_lines',
        withPlan: true,
        drawIndex: 106,
        clickIndex: 26,
        name: 'routeLayer',
        uuid: '1c38f3d7-b147-403c-b1c6-b0d943240ba6',
    },
    markerPoints: {
        group: 'portAreas',
        style: 'reference_points',
        withPlan: false ,
        drawIndex: 27,
        clickIndex: 27,
        name: 'markerPointsLayer',
        uuid: '1e497940-16c1-45e7-8471-26b45008d3a0',
    },
    wayPoint: {
        group: 'portAreas',
        style: 'waypoints',
        withPlan: true,
        drawIndex: 28,
        clickIndex: 28,
        name: 'wayPointsLayer',
        uuid: 'ada5e540-79df-4c99-88ec-e897e6fdf2df',
    },
};

export const CHART_COLORS = [
    '#264c99',
    '#a52a0d',
    '#bf7200',
    '#0c7012',
    '#720072',
    '#007294',
    '#b72153',
    '#4c7f00',
    '#8a2222',
    '#244a6f',
    '#723372',
    '#197f72',
    '#7f7f0c',
    '#4c2699',
    '#ac5600',
    '#680505',
    '#4b0c4d',
    '#256d49',
    '#3f577c',
    '#2c2e81',
    '#895619',
    '#10a017',
    '#8a0e62',
    '#d30b79',
    '#754227',
    '#7e930e',
    '#1f5969',
    '#4c6914',
    '#8e7b0e',
    '#084219',
    '#57270c',
];

export const DEFAULT_SWITCHS = {
    playbackManoeuvreInformationOnRightColumn: {
        label: 'Right column',
        comment: 'Manoeuvre information',
        value: true,
        group: true,
        section: 'manoeuvreInformation',
        loading: false,
        mode: 'playback',
        save: true,
    },
    playbackManoeuvreInformationOnChart: {
        label: 'On chart',
        comment: 'Manoeuvre information',
        value: true,
        group: true,
        section: 'manoeuvreInformation',
        loading: false,
        mode: 'playback',
        save: true,
    },

    timeManoeuvreInformationOnChart: {
        label: 'On chart',
        comment: 'Manoeuvre information',
        value: true,
        group: true,
        section: 'manoeuvreInformation',
        loading: false,
        mode: 'live',
        save: true,
    },

    chartManoeuvreInformationOnRightColumn: {
        label: 'Right column',
        comment: 'Manoeuvre information',
        value: true,
        group: true,
        section: 'manoeuvreInformation',
        loading: false,
        mode: 'search',
        save: true,
    },
    chartManoeuvreInformationOnChart: {
        label: 'On chart',
        comment: 'Manoeuvre information',
        value: true,
        group: true,
        section: 'manoeuvreInformation',
        loading: false,
        mode: 'search',
        save: true,
    },

    chartEnviromentalDataOnLeftColumn: {
        label: 'Left column',
        comment: 'Enviromental data',
        value: true,
        group: true,
        section: 'enviromentalData',
        loading: false,
        mode: 'search',
        save: true,
    },
    chartEnviromentalDataOnRightColumn: {
        label: 'Right column',
        comment: 'Enviromental data',
        value: true,
        group: true,
        section: 'enviromentalData',
        loading: false,
        mode: 'search',
        save: true,
    },
    chartEnviromentalDataOnChart: {
        label: 'On chart',
        comment: 'Enviromental data',
        value: false,
        group: true,
        section: 'enviromentalData',
        loading: false,
        mode: 'search',
        save: true,
    },

    playbackEnviromentalDataOnRightColumn: {
        label: 'Right column',
        comment: 'Enviromental data',
        value: true,
        group: true,
        section: 'enviromentalData',
        loading: false,
        mode: 'playback',
        save: true,
    },
    playbackEnviromentalDataOnChart: {
        label: 'On chart',
        comment: 'Enviromental data',
        value: false,
        group: true,
        section: 'enviromentalData',
        loading: false,
        mode: 'playback',
        save: true,
    },

    timeEnviromentalDataOnRightColumn: {
        label: 'Right column',
        comment: 'Enviromental data',
        value: true,
        group: true,
        section: 'enviromentalData',
        loading: false,
        mode: 'live',
        save: true,
    },
    timeEnviromentalDataOnChart: {
        label: 'On chart',
        comment: 'Enviromental data',
        value: false,
        group: true,
        section: 'enviromentalData',
        loading: false,
        mode: 'live',
        save: true,
    },

    windData: {
        label: 'Wind',
        comment: 'show wind data',
        value: true,
        group: false,
        section: 'metOcean',
        loading: false,
        mode: 'all',
        save: true,
    },
    tideData: {
        label: 'Tide',
        comment: 'show tide data',
        value: true,
        group: false,
        section: 'metOcean',
        loading: false,
        mode: 'all',
        save: true,
    },
    watercurrentData: {
        label: 'Current',
        comment: 'show current data',
        value: true,
        group: false,
        section: 'metOcean',
        loading: false,
        mode: 'all',
        save: true,
    },
    waveData: {
        label: 'Wave',
        comment: 'show wave data',
        value: true,
        group: false,
        section: 'metOcean',
        loading: false,
        mode: 'all',
        save: true,
    },
    sweptPath: {
        label: 'Swept path',
        comment: 'show swept path for all transits',
        value: true,
        group: false,
        section: 'dataDisplay',
        loading: false,
        mode: 'search',
        save: true,
    },
    identifyTransits: {
        label: 'Identify vessels',
        comment: 'Default identify vessels setting for this user in this port',
        value: true,
        group: false,
        section: 'dataDisplay',
        loading: false,
        mode: 'all',
        save: true,
    },
    vesselTracks: {
        label: 'Vessel tracks',
        comment: 'show vessel tracks ',
        value: false,
        group: false,
        section: 'dataDisplay',
        loading: false,
        mode: 'search',
        save: true,
    },
    vesselOutline: {
        label: 'Vessel outline',
        comment: 'show vessel outline',
        value: false,
        group: false,
        section: 'dataDisplay',
        loading: false,
        mode: 'search',
        save: false,
    },
    vesselOutColor: {
        label: 'Colour by type',
        comment: 'color vessel outline by type',
        value: false,
        group: false,
        section: 'dataDisplay',
        loading: false,
        disable: 'vesselOutline',
        mode: 'search',
        save: false,
    },
    // heatmap: {
    //     label: 'Heatmap',
    //     comment: 'show hetmap for all transits',
    //     value: false,
    //     group: false,
    //     section: 'aggregationLayers',
    //     loading: false,
    //     mode: 'search',
    //     save: false,
    // },
    // screenGrid: {
    //     label: 'screen grid',
    //     comment: 'show screen grid for all transits',
    //     value: false,
    //     group: false,
    //     section: 'aggregationLayers',
    //     loading: false,
    //     mode: 'search',
    //     save: false,
    // },
    vesselStatus: {
        label: 'Vessel status',
        value: false,
        group: false,
        loading: false,
        section: 'dataDisplay',
        mode: 'playback',
        save: false,
    },
    systemTags: {
        label: 'System tags',
        value: false,
        loading: false,
        section: 'dataDisplay',
        group: false,
        mode: 'playback',
        save: false,
    },
    routeTags: {
        label: 'Route tags',
        value: false,
        group: false,
        section: 'dataDisplay',
        loading: false,
        mode: 'playback',
        save: false,
    },
    debugTags: {
        label: 'Debug tags',
        value: false,
        group: true,
        section: 'dataDisplay',
        loading: false,
        mode: 'playback',
        save: false,
    },
    rawAIS: {
        label: 'Raw AIS',
        value: false,
        group: false,
        loading: false,
        section: 'dataDisplay',
        mode: 'playback',
        save: false,
    },
    centroid: {
        label: 'Corrected centroid',
        value: false,
        group: false,
        loading: false,
        section: 'dataDisplay',
        mode: 'playback',
        save: false,
    },
    smoothed: {
        label: 'Smoothed centroid',
        value: false,
        group: false,
        section: 'dataDisplay',
        loading: false,
        mode: 'playback',
        save: false,
    },
    pilotBoardingGround: {
        label: 'PBGs',
        value: false,
        comment: 'show pilot boarding ground',
        options: ['pilotBoardingGround'],
        group: false,
        section: 'analysisAreas',
        loading: false,
        mode: 'all',
        save: false,
    },
    channel: {
        label: 'Channels',
        comment: 'show channel',
        value: false,
        options: ['channel'],
        group: false,
        section: 'analysisAreas',
        loading: false,
        mode: 'all',
        save: false,
    },
    route: {
        label: 'Route',
        comment: 'route',
        value: false,
        options: ['route'],
        group: false,
        section: 'analysisAreas',
        loading: false,
        mode: 'all',
        save: false,
    },
    xtd: {
        label: 'XTD',
        comment: 'xtd',
        value: false,
        options: ['xtd'],
        group: false,
        section: 'analysisAreas',
        loading: false,
        mode: 'all',
        save: false,
    },
    noGoAreas: {
        label: 'noGoAreas',
        comment: 'noGoAreas',
        value: false,
        options: ['noGoAreas'],
        group: false,
        section: 'analysisAreas',
        loading: false,
        mode: 'all',
        save: false,
    },
    reservedAreas: {
        label: 'reservedAreas',
        comment: 'reservedAreas',
        value: false,
        options: ['reservedAreas'],
        group: false,
        section: 'analysisAreas',
        loading: false,
        mode: 'all',
        save: false,
    },
    anchorage: {
        label: 'Anchorages',
        comment: 'show anchorage',
        value: false,
        options: ['anchorage'],
        group: false,
        section: 'analysisAreas',
        loading: false,
        mode: 'all',
        save: false,
    },
    berth: {
        label: 'Berths',
        comment: 'show berth',
        value: false,
        options: ['berthLine', 'berth'],
        group: false,
        section: 'analysisAreas',
        loading: false,
        mode: 'all',
        save: false,
    },
    regionAreas: {
        label: 'Regions',
        comment: 'show port regions',
        value: false,
        options: ['regionAreas'],
        group: false,
        section: 'analysisAreas',
        loading: false,
        mode: 'all',
        save: false,
    },
    markerPoints: {
        label: 'Marker points',
        comment: 'show all marker points',
        value: false,
        options: ['markerPoints'],
        group: false,
        section: 'analysisAreas',
        loading: false,
        mode: 'all',
        save: false,
    },
    other: {
        label: 'Other',
        comment: 'show all other areas',
        value: false,
        options: ['swing', 'displayArea', 'corridorAreas', 'monitoringArea', 'portArea'],
        group: false,
        section: 'analysisAreas',
        loading: false,
        mode: 'all',
        save: false,
    },
};

export const ANALYIS_CHART_DATA = {
    xtd: {
        key: 'XTD',
        title: 'Centroid XTD',
        yLabel: 'Centroid XTD (m)',
        ToolTipLabel: 'Centroid XTD',
        unit: 'm',
        roundDeg: false,
        reverse: true,
        direction: true,
        decimals: 0,
    },
    swpxtd: {
        key: 'SWPXTD',
        title: 'Swept Path XTD',
        yLabel: 'Swept Path XTD (m)',
        ToolTipLabel: 'Swept Path XTD',
        unit: 'm',
        roundDeg: false,
        reverse: true,
        direction: true,
        decimals: 0,
    },
    sog: {
        key: 'SOG',
        title: 'Speed Over Ground',
        yLabel: 'SOG (kn)',
        ToolTipLabel: 'SOG',
        unit: 'kn',
        roundDeg: false,
        reverse: false,
        direction: false,
        decimals: 1,
    },
    heading: {
        key: 'Heading',
        title: 'Heading',
        yLabel: 'Heading (deg)',
        ToolTipLabel: 'Heading (deg)',
        unit: 'deg',
        roundDeg: true,
        reverse: true,
        direction: false,
        decimals: 1,
    },
    cog: {
        key: 'COG',
        title: 'Course Over Ground',
        yLabel: 'COG (deg)',
        ToolTipLabel: 'COG',
        unit: 'deg',
        roundDeg: false,
        reverse: true,
        direction: false,
        decimals: 1,
    },
    drift: {
        key: 'Drift',
        title: 'Drift',
        yLabel: 'Drift (deg)',
        ToolTipLabel: 'Drift',
        unit: 'deg',
        roundDeg: false,
        reverse: true,
        direction: true,
        decimals: 1,
    },
    rot: {
        key: 'ROT',
        title: 'Rate of Turn',
        yLabel: 'ROT (deg/min)',
        ToolTipLabel: 'ROT',
        unit: 'deg/min',
        roundDeg: false,
        reverse: true,
        direction: true,
        decimals: 0,
    },
    crot: {
        key: 'CROT',
        title: 'Calc. Rate of Turn',
        yLabel: 'CROT (deg/min)',
        ToolTipLabel: 'CROT',
        unit: 'deg/min',
        roundDeg: false,
        reverse: true,
        direction: true,
        decimals: 0,
    },
    duration: {
        key: 'Duration',
        title: 'Duration',
        yLabel: 'Duration (s)',
        ToolTipLabel: 'Duration',
        unit: 's',
        roundDeg: false,
        reverse: false,
        direction: false,
        decimals: 1,
    },
};
